<div class="info-container">
  <ng-container *ngIf="isGroupOrder; then GroupTemplate else DefaultTemplate"></ng-container>
  <ng-template #GroupTemplate>
    <div class="table-info-container">
      <h2>
        <span langkey="phGroupOrder_Payment_Group"></span>
        <span class="groupName">{{groupName}}</span>
      </h2>
    </div>
  </ng-template>
  <ng-template #DefaultTemplate>
    <div *ngIf="tableNo$ | async; let tableNo" class="table-info-container">
      <h2>
        <span langkey="phInHouse_Payment_Table"></span>
        <span class="tableNo">{{tableNo}}</span>
      </h2>
    </div>
  </ng-template>
</div>
<div class="selection-container">
  <div class="select-options">
    <div class="ya-webshop-button-container drop-toggle">
      <button mat-flat-button (click)="showSelectOptions()">
        <span langkey="phInHouse_Payment_Select_Btn"></span>
      </button>
    </div>
    <ng-container *ngIf="selectOptionsShown">
      <div class="drop-show">
        <div class="drop-show_selection">
          <div class="drop-selection_option">
            <mat-button-toggle-group #toggleMenu="matButtonToggleGroup">
              <mat-button-toggle [checked]="true" (click)="selectAll();showSelectOptions()">
                <span langkey="phInHouse_Payment_Select_All"></span>
              </mat-button-toggle>
              <div class="list-seperator"></div>
              <mat-button-toggle [checked]="true" (click)="selectMyItems();showSelectOptions()">
                <span langkey="phInHouse_Payment_Select_Own_Items"></span>
              </mat-button-toggle>
              <div class="list-seperator"></div>
              <mat-button-toggle [checked]="true" (click)="selectNone();showSelectOptions()">
                <span langkey="phInHouse_Payment_Select_None"></span>
              </mat-button-toggle>
            </mat-button-toggle-group>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <ng-container *ngIf="sortOptions$ | async; let sortOptions">
    <div class="sort-options">
      <div class="sort-options__input">
        <select a11y_Select class="ya-input-text sort-options_input__text"
          (change)="sortOptions[$event.currentTarget.value].sortBy()">
          <ng-container *ngFor="let sortOption of sortOptions; let i = index;">
            <option [value]="i" [selected]="sortOption.selected" [langkey]="sortOption.langkey"></option>
          </ng-container>
        </select>
        <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-pfeil-unten-voll"></div>
      </div>
    </div>
  </ng-container>
</div>
<div class="warenkorb">
  <div class="col">
    <ng-container *ngIf="orders$ | async; let orders">
      <div class="ya-item-list-contaner">
        <ng-container *ngFor="let order of orders; let i = index; trackBy: trackSeatOrderBy">
          <div class="order-list-content">
            <div class="user-container" [class.disabled]="order.isLockedForPayment" (click)="NotAvaliableDialog(order)">
              <div class="user-payment-state">
                <ng-container *ngIf="order.isLockedForPayment">
                  <div class="list-selection selection-state">
                    <div class="icon-container">
                      <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-bezahlen-disabled"></div>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="!order.isLockedForPayment">
                  <div class="list-selection selection-state">
                    <div class="checkBox-list-container">
                      <mat-checkbox class="checkItems custom-ripple" [checked]="order.isSelected"
                        (change)="order.toggleSelection(!order.isSelected)">
                      </mat-checkbox>
                    </div>
                  </div>
                </ng-container>
                <div class="icon-container">
                  <div class="inline-icon"
                    [inlineSVG]="order.seat ? 'shop-icons.svg#ya-hypersoft-user-list-single' : 'shop-icons.svg#ya-user-group'">
                  </div>
                </div>
              </div>
              <div class="user-info">
                <ng-container *ngIf="isGroupOrder then GroupTemplate else DefaultTemlate"></ng-container>
                <ng-template #GroupTemplate>
                  <div class="user_info_name">
                    <h3>{{order.name}}</h3>
                  </div>
                </ng-template>
                <ng-template #DefaultTemlate>
                  <div class="user_info_name">
                    <ng-container *ngIf="order.isGuest && order.name && order.name.length > 0 then user else guest">
                    </ng-container>
                    <ng-template #user>
                      <h3>{{order.name}}</h3>
                    </ng-template>
                    <ng-template #guest>
                      <h3 langkey="phInHouseLocalBasket_Guest_Label"></h3>
                    </ng-template>
                  </div>
                  <div class="user-info_place">
                    <h3 *ngIf="order.seat" class="userPlace">{{SetUserPlace(order.seat)}}</h3>
                  </div>
                </ng-template>
              </div>
            </div>
            <ng-container *ngFor="let item of order.items; let i = index; trackBy: trackSeatOrderItemBy">
              <div class="tag-wrapper" [class.disabled]="item.isLockedForPayment" (click)="NotAvaliableDialog(item)">
                <div class="info">
                  <div class="item">
                    <div class="list-selection">
                      <ng-container *ngIf="item.isLockedForPayment">
                        <div class="icon-container">
                          <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-bezahlen-disabled"></div>
                        </div>
                      </ng-container>
                      <ng-container *ngIf="!item.isLockedForPayment">
                        <div class="checkBox-list-container">
                          <mat-checkbox class="checkItems custom-ripple" [checked]="item.isSelected"
                            (change)="item.toggleSelection(!item.isSelected)" [checked]="item.isSelected">
                          </mat-checkbox>
                        </div>
                      </ng-container>
                    </div>
                    <div class="orderItems-label-container">
                      <span class="item-label">{{item.count >1? item.count + "x " + item.label: item.label}}</span>
                    </div>
                  </div>
                  <div class="selection-wrapper">
                    <ng-container *ngIf="item.isSelected && item.count > 1">
                      <div class="amountChanger">
                        <div class="minus" (click)="item.decrement()">-</div>
                        <div class="amount">({{item.selectedCount}}/{{item.count}})</div>
                        <div class="plus" (click)="item.increment()">+</div>
                      </div>
                    </ng-container>
                  </div>
                  <div class="item-price">
                    <span class="item-price_label">{{formatCurrency(item.price)}}</span>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </div>
  <div class="col second">
    <ng-container *ngIf="showTipping">
      <div class="list-seperator"></div>
      <div class="table-order-sum">
        <span langkey="phGlobal_Sum"></span>
        <span>{{formatCurrency(sum$ | async)}}</span>
      </div>
      <div class="trinkgeld-container">
        <span langkey="phWebshop_Shippingcart_tip"></span>
        <div class="trinkgeld-slider-container">
          <mat-slider #tipSlider min="0" max="50" step="1" (change)="onSliderValueChange()" [(ngModel)]="tipSliderValue"
            thumbLabel [displayWith]="formatTipSliderLabel"></mat-slider>
        </div>
        <div class="trinkgeld-amount">
          <div class="ya-input-container">
            <input a11y_Input numericInput inputmode="decimal" class="ya-input-text" (blur)="setWebView()"
              (change)="onInputTrinkgeldChange($event)" onfocus="this.select()" onpaste="return false;"
              ondrop="return false" [(ngModel)]="tipInputValue">
          </div>
          <span>&nbsp;{{currencySymbol}}</span>
        </div>
      </div>
    </ng-container>
    <div class="price-container total top-seperator">
      <span langkey="phWebshop_ShippingCart_Total"></span>
      <span>{{formatCurrency(total$ | async)}}</span>
    </div>
    <ng-container *ngIf="canContinue$ | async; let canContinue; then shippingCartActiveBtn else shippingCartDisableBtn">
    </ng-container>
    <ng-template #shippingCartActiveBtn>
      <div class="ya-webshop-button-container continue-button">
        <button mat-flat-button (click)="continue()" data-testid="inhouse-payment-continue-button"><span langkey="phInHouse_Continue_Btn"></span></button>
      </div>
    </ng-template>
    <ng-template #shippingCartDisableBtn>
      <div class="ya-webshop-button-container continue-button">
        <button mat-flat-button disabled><span langkey="phInHouse_Continue_Btn"></span></button>
      </div>
    </ng-template>
  </div>
</div>